import styled from 'styled-components';

export const TableContainer = styled.div`
  background: ${(p) => p.theme.surface};
  border: 1px solid ${(p) => p.theme.border};
  border-radius: ${(p) => p.theme.radiusLg};
  box-shadow: ${(p) => p.theme.shadowSm};
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 0.9rem 1rem;
    text-align: left;
    border-bottom: 1px solid ${(p) => p.theme.border};
    vertical-align: middle;
    font-size: 0.9rem;
    color: ${(p) => p.theme.textPrimary};
  }

  th {
    background: ${(p) => p.theme.surfaceAlt};
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: ${(p) => p.theme.textMuted};
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  tbody tr:hover td {
    background: ${(p) => p.theme.surfaceAlt};
  }
`;

export default Table;
